var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelioLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.000488281,
    width: 52,
    height: 52,
    rx: 18,
    fill: "#2C67E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9995 34.5904C30.7445 34.5904 34.5911 30.7438 34.5911 25.9988C34.5911 21.2538 30.7445 17.4072 25.9995 17.4072C21.2545 17.4072 17.408 21.2538 17.408 25.9988C17.408 30.7438 21.2545 34.5904 25.9995 34.5904Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9998 13.2081C26.8858 13.2081 27.6041 12.4898 27.6041 11.6038C27.6041 10.7178 26.8858 9.99951 25.9998 9.99951C25.1138 9.99951 24.3955 10.7178 24.3955 11.6038C24.3955 12.4898 25.1138 13.2081 25.9998 13.2081Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3958 27.6036C41.2818 27.6036 42.0001 26.8853 42.0001 25.9993C42.0001 25.1133 41.2818 24.395 40.3958 24.395C39.5098 24.395 38.7915 25.1133 38.7915 25.9993C38.7915 26.8853 39.5098 27.6036 40.3958 27.6036Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6045 27.6036C12.4906 27.6036 13.2088 26.8853 13.2088 25.9993C13.2088 25.1133 12.4906 24.395 11.6045 24.395C10.7185 24.395 10.0002 25.1133 10.0002 25.9993C10.0002 26.8853 10.7185 27.6036 11.6045 27.6036Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9998 41.9986C26.8858 41.9986 27.6041 41.2803 27.6041 40.3943C27.6041 39.5083 26.8858 38.79 25.9998 38.79C25.1138 38.79 24.3955 39.5083 24.3955 40.3943C24.3955 41.2803 25.1138 41.9986 25.9998 41.9986Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1793 38.5734C37.5024 38.5734 38.5749 37.5009 38.5749 36.1778C38.5749 34.8548 37.5024 33.7822 36.1793 33.7822C34.8562 33.7822 33.7837 34.8548 33.7837 36.1778C33.7837 37.5009 34.8562 38.5734 36.1793 38.5734Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8209 18.2155C17.144 18.2155 18.2165 17.143 18.2165 15.8199C18.2165 14.4969 17.144 13.4243 15.8209 13.4243C14.4978 13.4243 13.4253 14.4969 13.4253 15.8199C13.4253 17.143 14.4978 18.2155 15.8209 18.2155Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1793 18.2155C37.5024 18.2155 38.5749 17.143 38.5749 15.8199C38.5749 14.4969 37.5024 13.4243 36.1793 13.4243C34.8562 13.4243 33.7837 14.4969 33.7837 15.8199C33.7837 17.143 34.8562 18.2155 36.1793 18.2155Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8209 38.5734C17.144 38.5734 18.2165 37.5009 18.2165 36.1778C18.2165 34.8548 17.144 33.7822 15.8209 33.7822C14.4978 33.7822 13.4253 34.8548 13.4253 36.1778C13.4253 37.5009 14.4978 38.5734 15.8209 38.5734Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelioLogo);
export default __webpack_public_path__ + "static/media/helioLogo.28b14f998b9a01f4e4856fad273bfcf8.svg";
export { ForwardRef as ReactComponent };